import React from "react";
import {Box} from "@mui/material";


const DefaultLayout = ({type, maxContent, children}) => {
        return <Box sx={{ mb: 5}}>
            {children}
        </Box>

}

export default DefaultLayout
